export const NatureOfBusinessEnum = [
  {
    enum_Group: 'NatureOfBusinessEnum',
    enum_Group_Text: null,
    valueMember: 2,
    displayMember: 'Briquettes/ Pellets',
    Enum_Name: 'Briquettes_Pellets',
    sequence: 2,
  },
  {
    enum_Group: 'NatureOfBusinessEnum',
    enum_Group_Text: null,
    valueMember: 3,
    displayMember: 'Industrial Biowaste',
    Enum_Name: 'IndustrialBiowaste',
    sequence: 3,
  },
  {
    enum_Group: 'NatureOfBusinessEnum',
    enum_Group_Text: null,
    valueMember: 4,
    displayMember: 'Biomass Consumer',
    Enum_Name: 'BiomassConsumer',
    sequence: 4,
  },
  {
    enum_Group: 'NatureOfBusinessEnum',
    enum_Group_Text: null,
    valueMember: 5,
    displayMember: 'Biofuel/ Bioenergy',
    Enum_Name: 'Biofuel_Bioenergy',
    sequence: 5,
  },
  {
    enum_Group: 'NatureOfBusinessEnum',
    enum_Group_Text: null,
    valueMember: 6,
    displayMember: 'Biofuel Consumer',
    Enum_Name: 'BiofuelConsumer',
    sequence: 6,
  },
  {
    enum_Group: 'NatureOfBusinessEnum',
    enum_Group_Text: null,
    valueMember: 7,
    displayMember: 'Bank/ NBFC',
    Enum_Name: 'Bank_NBFC',
    sequence: 7,
  },
  {
    enum_Group: 'NatureOfBusinessEnum',
    enum_Group_Text: null,
    valueMember: 8,
    displayMember: 'Insurance Company',
    Enum_Name: 'InsuranceCompany',
    sequence: 8,
  },
  {
    enum_Group: 'NatureOfBusinessEnum',
    enum_Group_Text: null,
    valueMember: 9,
    displayMember: 'Transport',
    Enum_Name: 'Transport',
    sequence: 9,
  },
  {
    enum_Group: 'NatureOfBusinessEnum',
    enum_Group_Text: null,
    valueMember: 10,
    displayMember: 'Warehouse/ Storage',
    Enum_Name: 'Warehouse_Storage',
    sequence: 10,
  },
  {
    enum_Group: 'NatureOfBusinessEnum',
    enum_Group_Text: null,
    valueMember: 11,
    displayMember: 'Platform Partner',
    Enum_Name: 'PlatformPartner',
    sequence: 11,
  },
  {
    enum_Group: 'NatureOfBusinessEnum',
    enum_Group_Text: null,
    valueMember: 12,
    displayMember: 'Platform Support',
    Enum_Name: 'PlatformSupport',
    sequence: 12,
  },
  {
    enum_Group: 'NatureOfBusinessEnum',
    enum_Group_Text: null,
    valueMember: 1,
    displayMember: 'Agricultural Products',
    Enum_Name: 'AgriculturalProducts',
    sequence: 1,
  },
];

export const BusinessTypeEnum = [
  {
    enum_Group: 'BusinessTypeEnum',
    enum_Group_Text: null,
    valueMember: 1,
    displayMember: 'Proprietorship',
    Enum_Name: 'Proprietorship',
    sequence: 1,
  },
  {
    enum_Group: 'BusinessTypeEnum',
    enum_Group_Text: null,
    valueMember: 2,
    displayMember: 'Private Limited Co.',
    Enum_Name: 'PrivateLimitedCo',
    sequence: 2,
  },
  {
    enum_Group: 'BusinessTypeEnum',
    enum_Group_Text: null,
    valueMember: 3,
    displayMember: 'Partnership',
    Enum_Name: 'Partnership',
    sequence: 3,
  },
  {
    enum_Group: 'BusinessTypeEnum',
    enum_Group_Text: null,
    valueMember: 4,
    displayMember: 'Public Limited Co.',
    Enum_Name: 'PublicLimitedCo',
    sequence: 4,
  },
  {
    enum_Group: 'BusinessTypeEnum',
    enum_Group_Text: null,
    valueMember: 5,
    displayMember: 'LLP',
    Enum_Name: 'LLP',
    sequence: 5,
  },
  {
    enum_Group: 'BusinessTypeEnum',
    enum_Group_Text: null,
    valueMember: 6,
    displayMember: 'Trust',
    Enum_Name: 'Trust',
    sequence: 6,
  },
  {
    enum_Group: 'BusinessTypeEnum',
    enum_Group_Text: null,
    valueMember: 7,
    displayMember: 'Society',
    Enum_Name: 'Society',
    sequence: 7,
  },
  {
    enum_Group: 'BusinessTypeEnum',
    enum_Group_Text: null,
    valueMember: 8,
    displayMember: 'NGO',
    Enum_Name: 'NGO',
    sequence: 8,
  },
  {
    enum_Group: 'BusinessTypeEnum',
    enum_Group_Text: null,
    valueMember: 9,
    displayMember: 'FPO',
    Enum_Name: 'FPO',
    sequence: 9,
  },
  {
    enum_Group: 'BusinessTypeEnum',
    enum_Group_Text: null,
    valueMember: 10,
    displayMember: 'SHG',
    Enum_Name: 'SHG',
    sequence: 10,
  },
];

export const BuyerSellerEnum = [
  {
    enum_Group: 'BuyerSellerEnum',
    enum_Group_Text: null,
    valueMember: 1,
    displayMember: 'Buy Only',
    Enum_Name: 'BuyOnly',
    sequence: 1,
  },
  {
    enum_Group: 'BuyerSellerEnum',
    enum_Group_Text: null,
    valueMember: 2,
    displayMember: 'Sell Only',
    Enum_Name: 'SellOnly',
    sequence: 2,
  },
  {
    enum_Group: 'BuyerSellerEnum',
    enum_Group_Text: null,
    valueMember: 3,
    displayMember: 'Both',
    Enum_Name: 'Both',
    sequence: 3,
  },
];

export const BuyerSellerTypeEnum = [
  { value: 1, label: 'Just here to Buy for my consumption' },
  { value: 2, label: 'Just here to Sell what I make' },
  { value: 3, label: 'Buy feedstock, convert & sell what I make' },
];

export const TypeOfIndividualEnum = [
  // {
  //   enum_Group: 'TypeOfIndividualEnum',
  //   enum_Group_Text: null,
  //   valueMember: 1,
  //   Enum_Name: 'Farmer',
  //   displayMember: 'Farmer',
  //   sequence: 1,
  // },
  {
    enum_Group: 'TypeOfIndividualEnum',
    enum_Group_Text: null,
    valueMember: 4,
    Enum_Name: 'BusinessOrganisation',
    displayMember: 'Business Organisation',
    sequence: 4,
  },
  {
    enum_Group: 'TypeOfIndividualEnum',
    enum_Group_Text: null,
    valueMember: 2,
    Enum_Name: 'DriverAndVehicleOwner',
    displayMember: 'Driver And Vehicle Owner',
    sequence: 2,
  },
  // {
  //   enum_Group: 'TypeOfIndividualEnum',
  //   enum_Group_Text: null,
  //   valueMember: 3,
  //   Enum_Name: 'PersonAssociatedwithAgricultureOrBioenergy',
  //   displayMember: 'Person Associated with Agriculture or Bioenergy',
  //   sequence: 3,
  // },
  // {
  //   enum_Group: 'TypeOfIndividualEnum',
  //   enum_Group_Text: null,
  //   valueMember: 5,
  //   Enum_Name: 'Driver',
  //   displayMember: 'Driver',
  //   sequence: 5,
  // },
  {
    enum_Group: 'TypeOfIndividualEnum',
    enum_Group_Text: null,
    valueMember: 6,
    Enum_Name: 'TransportCompany',
    displayMember: 'Transport Company',
    sequence: 6,
  },
  // {
  //   enum_Group: 'TypeOfIndividualEnum',
  //   enum_Group_Text: null,
  //   valueMember: 7,
  //   Enum_Name: 'NBFCBankingInstitute',
  //   displayMember: 'NBFC/ Banking Institute',
  //   sequence: 7,
  // },
  // {
  //   enum_Group: 'TypeOfIndividualEnum',
  //   enum_Group_Text: null,
  //   valueMember: 8,
  //   Enum_Name: 'Quality_Testing_Laboratory',
  //   displayMember: 'Quality Testing Laboratory',
  //   sequence: 8,
  // },
  // {
  //   enum_Group: 'TypeOfIndividualEnum',
  //   enum_Group_Text: null,
  //   valueMember: 9,
  //   Enum_Name: 'FPO',
  //   displayMember: 'FPO',
  //   sequence: 9,
  // },
  // {
  //   enum_Group: 'TypeOfIndividualEnum',
  //   enum_Group_Text: null,
  //   valueMember: 10,
  //   Enum_Name: 'SelfHelpGroup',
  //   displayMember: 'Self Help Group',
  //   sequence: 10,
  // },
];

// Helper function to get display member by value member
export const getNatureOfBusinessDisplay = (valueMember) => {
  const item = NatureOfBusinessEnum.find((item) => item.valueMember === valueMember);
  return item ? item.displayMember : '';
};

// Helper function to get Enum_Name by value member (for API)
export const getNatureOfBusinessEnumName = (valueMember) => {
  const item = NatureOfBusinessEnum.find((item) => item.valueMember === valueMember);
  return item ? item.Enum_Name : '';
};

// Helper function to get value member by display member
export const getNatureOfBusinessValue = (displayMember) => {
  const item = NatureOfBusinessEnum.find((item) => item.displayMember === displayMember);
  return item ? item.valueMember : null;
};

// Helper function to get value member by Enum_Name (for API)
export const getNatureOfBusinessValueByEnumName = (enumName) => {
  const item = NatureOfBusinessEnum.find((item) => item.Enum_Name === enumName);
  return item ? item.valueMember : null;
};

// Helper function to get all display members as an array (for UI)
export const getNatureOfBusinessOptions = () => {
  return NatureOfBusinessEnum.map((item) => ({
    value: item.valueMember,
    label: item.displayMember,
  }));
};

// Helper function to get all Enum_Names as an array (for API)
export const getNatureOfBusinessEnumOptions = () => {
  return NatureOfBusinessEnum.map((item) => ({
    value: item.valueMember,
    enumName: item.Enum_Name,
    label: item.displayMember,
  }));
};

// Helper function to get all display members as an array (for UI)
export const getBusinessTypeOptions = () => {
  return BusinessTypeEnum.map((item) => ({
    value: item.valueMember,
    label: item.displayMember,
  }));
};

// Helper function to get all Enum_Names as an array (for API)
export const getBusinessTypeEnumOptions = () => {
  return BusinessTypeEnum.map((item) => ({
    value: item.valueMember,
    enumName: item.Enum_Name,
    label: item.displayMember,
  }));
};

// Helper function to get display member by value member
export const getBusinessTypeDisplay = (valueMember) => {
  const item = BusinessTypeEnum.find((item) => item.valueMember === valueMember);
  return item ? item.displayMember : '';
};

// Helper function to get Enum_Name by value member (for API)
export const getBusinessTypeEnumName = (valueMember) => {
  const item = BusinessTypeEnum.find((item) => item.valueMember === valueMember);
  return item ? item.Enum_Name : '';
};

// Helper function to get all display members as an array (for UI)
export const getBuyerSellerOptions = () => {
  return BuyerSellerEnum.map((item) => ({
    value: item.valueMember,
    label: item.displayMember,
  }));
};

// Helper function to get all Enum_Names as an array (for API)
export const getBuyerSellerEnumOptions = () => {
  return BuyerSellerEnum.map((item) => ({
    value: item.valueMember,
    enumName: item.Enum_Name,
    label: item.displayMember,
  }));
};

// Helper function to get display member by value member
export const getBuyerSellerDisplay = (valueMember) => {
  const item = BuyerSellerEnum.find((item) => item.valueMember === valueMember);
  return item ? item.displayMember : '';
};

// Helper function to get Enum_Name by value member (for API)
export const getBuyerSellerEnumName = (valueMember) => {
  const item = BuyerSellerEnum.find((item) => item.valueMember === valueMember);
  return item ? item.Enum_Name : '';
};

export const getBuyerSellerTypeOptions = () => BuyerSellerTypeEnum;

// Helper function to get all display members as an array (for UI)
export const getTypeOfIndividualOptions = () => {
  return TypeOfIndividualEnum.map((item) => ({
    value: item.valueMember,
    label: item.displayMember,
  }));
};

// Helper function to get all Enum_Names as an array (for API)
export const getTypeOfIndividualEnumOptions = () => {
  return TypeOfIndividualEnum.map((item) => ({
    value: item.valueMember,
    enumName: item.Enum_Name,
    label: item.displayMember,
  }));
};

// Helper function to get display member by value member
export const getTypeOfIndividualDisplay = (valueMember) => {
  const item = TypeOfIndividualEnum.find((item) => item.valueMember === valueMember);
  return item ? item.displayMember : '';
};

// Helper function to get Enum_Name by value member (for API)
export const getTypeOfIndividualEnumName = (valueMember) => {
  const item = TypeOfIndividualEnum.find((item) => item.valueMember === valueMember);
  return item ? item.Enum_Name : '';
};

export default {
  getNatureOfBusinessOptions,
  getNatureOfBusinessEnumOptions,
  getNatureOfBusinessDisplay,
  getNatureOfBusinessEnumName,
  getNatureOfBusinessValue,
  getNatureOfBusinessValueByEnumName,
  getBusinessTypeOptions,
  getBusinessTypeEnumOptions,
  getBusinessTypeDisplay,
  getBusinessTypeEnumName,
  getBuyerSellerOptions,
  getBuyerSellerEnumOptions,
  getBuyerSellerDisplay,
  getBuyerSellerEnumName,
  getBuyerSellerTypeOptions,
  getTypeOfIndividualOptions,
  getTypeOfIndividualEnumOptions,
  getTypeOfIndividualDisplay,
  getTypeOfIndividualEnumName,
};
